import { all, takeLatest, put, call, fork, select } from "redux-saga/effects";
import { actions, constants } from "./actions";
import { initState } from "./reducer";
import { apiV2 } from "../../services/api";
import { callReportsUtils } from "./utils";
import moment from "moment";
import { fetchOrSelectCallTakers } from "../callTakers/sagas";

const { FETCH_LIST, DELETE_CALL_REPORT } = constants;
const { fetchList, deleteCallReport, updateDateFilter } = actions;

function formatToDate(dt) {
  return moment(dt).add(1, "day").format("YYYY-MM-DD");
}

function formatFromDate(dt) {
  return moment(dt).format("YYYY-MM-DD");
}

// Action sagas - async
function* fetchListRequest() {
  yield takeLatest("FETCH_LIST/REQUEST", function* ({ payload }) {
    yield put(updateDateFilter(payload));

    const fromDate = yield select((state) => state.callReports.fromDateFilter);
    const toDate = yield select((state) => state.callReports.toDateFilter);

    try {
      const response = yield call(apiV2.callReports.getAll, {
        startDate: formatFromDate(fromDate),
        endDate: formatToDate(toDate),
        type: "ORIGIN",
      });
      const callTakers = yield call(fetchOrSelectCallTakers);

      // V2 response is already in camelCase, no conversion needed
      // Transform V2 paginated response to the format expected by the reducer
      const callReportsList = response.data || [];

      yield put(
        fetchList.success({
          source: FETCH_LIST,
          list: callReportsList,
          callTakers,
        })
      );
    } catch (err) {
      yield put(
        fetchList.failure({
          source: FETCH_LIST,
          message: "Unable to fetch call reports, please try again.",
        })
      );
    }
  });
}

function* deleteCallReportRequest() {
  yield takeLatest("DELETE_CALL_REPORT/REQUEST", function* ({ payload }) {
    try {
      // V2 API returns 204 No Content on successful deletion
      yield call(apiV2.callReports.delete, payload.callReportId);

      // Refetch the list after deletion
      yield put(
        fetchList.request({
          fromDate: payload.startDate,
          toDate: payload.endDate,
        })
      );

      yield put(
        deleteCallReport.success({
          source: DELETE_CALL_REPORT,
          message: "Successfully deleted call report.",
          list: [], // Will be populated by the FETCH_LIST success action
        })
      );
    } catch (err) {
      yield put(
        deleteCallReport.failure({
          source: DELETE_CALL_REPORT,
          message: "Unable to delete call report, please try again.",
        })
      );
    }
  });
}

function* resetCallReportFiltersRequest() {
  yield takeLatest("RESET_CALL_REPORTS_FILTERS", function* () {
    yield put(
      fetchList.request({
        fromDate: initState.fromDateFilter,
        toDate: initState.toDateFilter,
      })
    );
  });
}

// Watcher sagas
export default function* rootSaga() {
  yield all([
    fork(fetchListRequest),
    fork(deleteCallReportRequest),
    fork(resetCallReportFiltersRequest),
  ]);
}
